import React from 'react';
import * as R from 'ramda';
import { connect } from 'react-redux';
import Browse from './Browse/Browse';
import Category from './Category/Category';
import Home from './Home/Home';
import Query from './Query/Query';

const mapStateToProps = state => ({
  currentTab: state.tab.byId[state.router.params.id],
  id: state.router.params.id,
});

const TabSwitcher = ({ id, currentTab }) => {
  if (id === 'home') {
    return (
      <Home keyWindow={`/tab/${id}`} />
    );
  } else if (id === 'browse') {
    return (
      <Browse keyWindow={`/tab/${id}`} />
    );
  } else if (currentTab && currentTab.category) {
    return (
      <Category keyWindow={`/tab/${currentTab.id}`} />
    );
  } else if (currentTab && currentTab.query) {
    return (
      <Query keyWindow={`/tab/${currentTab.id}`} />
    );
  }
  return (<div>Invalid Tab</div>);
};

export default connect(mapStateToProps)(TabSwitcher);
